import { FailureCodes } from 'components/pages/SomethingWentWrongPage/constants';
import Snackbar from 'components/shared/Toaster/ToasterWithoutState';
import { APP_CONFIG } from 'constants/config';
import { IErrorType } from 'interfaces';
import { useRouter } from 'next/router';
import { useSetRecoilState } from 'recoil';
import { userModelState } from 'recoil/atoms/userAtoms';
import { getUserRequest, updateUserActiveClientRequest } from 'recoil/selectors/usersSelectors';
import logger from 'utils/logger';

import { findUserClientByClientUuid } from 'recoil/selectors/clientsSelectors';
import { cleanStorage } from 'utils/cleanStorage';
import { UserEntity } from '../../../entityTypes/User';
import { ROUTES_PATH_URLS } from '../constants/routes';

export const SET_USER_DATA_ERROR_MESSAGES = {
  NO_RESULTS_FROM_SET_USER_DATA:
    'Unable with request - back-end user and token problem, corrupt get-user-info data or incorrect internal coding error',
  TOKEN_NOT_PROVIDED: 'Token must be provided.',
};

const useSetUserData = () => {
  const setUserModel = useSetRecoilState(userModelState);
  const router = useRouter();

  const setUserData = async (accessToken: string, initiator: string) => {
    try {
      if (!accessToken) {
        Snackbar.error(
          `${SET_USER_DATA_ERROR_MESSAGES.TOKEN_NOT_PROVIDED}, accessToken: ${JSON.stringify(
            accessToken
          )}, Initiator: ${initiator}`
        );
        return;
      }
      logger(
        `useSetUserData :: getUserRequest - Initiator: ${initiator}, setUserData : ${accessToken}`
      );
      const results = await getUserRequest(accessToken);
      const { userModel: resUser } = results;
      if (!resUser.userClients.some((uc) => uc.clientUuid === resUser.activeClientUuid)) {
        resUser.activeClientUuid = resUser.userClients[0]?.clientUuid;
        cleanStorage();
        await updateUserActiveClientRequest(resUser.userClients[0]?.clientUuid, accessToken);
      }

      const userClient = await findUserClientByClientUuid(resUser.activeClientUuid, accessToken);
      const updatedUserModel: UserEntity = {
        ...resUser,
        accessToken,
        tableSettings: [],
        oktaClientId: APP_CONFIG.oktaClientId,
        selectedUserClient: userClient,
        isAuth: true,
        signInRetries: 0,
      };
      setUserModel(updatedUserModel);
      return true;
    } catch (error) {
      logger('Error in getUserRequest: ', error);
      const err = error as IErrorType;
      if (err?.code !== 401) {
        if (err?.code === 404) {
          router.push(ROUTES_PATH_URLS.something_went_wrong(FailureCodes.USER_NOT_EXIST));
        } else {
          router.push(ROUTES_PATH_URLS.something_went_wrong(''));
        }
      }

      return false;
    }
  };

  return setUserData;
};

export default useSetUserData;
